function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import digitalData from 'digital-data';
import { getState } from '../analytics-state.js';
import { STASH, NOT_APPLICABLE, BIP_PAGE, SHOPPABLE_IMAGES_DRAWER } from '../constants.js';
const eventOriginatedFromProductPodOrFbt = path => {
  return (path || []).reverse().find(name => name.match(/ProductPodDefaultMobile\[/i) || name.match(/ProductPodDefaultDesktop\[/i) || name.match(/ProductPodDesktop\[/i) || name.match(/ProductPodMobile\[/i) || name.match(/productpod\[/i) || name.match(/frequentlyboughttogether\[/i));
};
const eventOriginatedFromPromotionProducts = path => {
  return !!(path || []).find(name => name.match(/promotionproducts/i));
};
const eventOriginatedFromApplianceBundles = path => {
  return !!(path || []).find(name => name.match(/ApplianceBundles\[/i));
};
const isFromPackagePageOrPackageMini = path => {
  const packagePageRE = /packagepage/i;
  const packageMiniRE = /packagesmini/i;
  const isFromPackages = path.find(function () {
    let part = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return packagePageRE.test(part) || packageMiniRE.test(part);
  });
  return !!isFromPackages;
};
export const getSectionFromPath = _ref => {
  let {
    path,
    cartOptions
  } = _ref;
  const buyBoxRE = /buybox/i;
  const sampleBoxRE = /sample/i;
  const isFromBuyBox = (path || []).find(function () {
    let part = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return buyBoxRE.test(part);
  });
  const isSampleBox = (path || []).find(function () {
    let part = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return sampleBoxRE.test(part);
  });
  const isFromPackages = isFromPackagePageOrPackageMini(path);
  if (eventOriginatedFromPromotionProducts(path)) {
    return 'module';
  }
  if (isFromBuyBox) {
    return 'buybox';
  }
  if (isSampleBox) {
    return 'sample';
  }
  if (isFromPackages) {
    var _cartOptions$packageI;
    return (cartOptions === null || cartOptions === void 0 ? void 0 : (_cartOptions$packageI = cartOptions.packageInfo) === null || _cartOptions$packageI === void 0 ? void 0 : _cartOptions$packageI.packageName) || 'n/a';
  }
  if ((cartOptions === null || cartOptions === void 0 ? void 0 : cartOptions.component) === SHOPPABLE_IMAGES_DRAWER) {
    return 'n/a';
  }
  return 'unknown';
};
export const getTargetFromPath = _ref2 => {
  let {
    path
  } = _ref2;
  const lowerCasePath = path.map(name => (name || '').toLowerCase());
  const atcIndex = lowerCasePath.findIndex(part => /^addtocart/i.test(part));
  return atcIndex > -1 ? 'atc' : '';
};
const getItemsFromCartReqParams = (cartReqParams, cartOptions, path) => {
  const state = getState();
  const recommendation = {
    recommendationType: (cartOptions === null || cartOptions === void 0 ? void 0 : cartOptions.recommendationType) || (cartOptions === null || cartOptions === void 0 ? void 0 : cartOptions.sharedSection) || NOT_APPLICABLE,
    pageType: state === null || state === void 0 ? void 0 : state.pageType,
    displayPosition: NOT_APPLICABLE,
    strategy: NOT_APPLICABLE,
    recommendationVersion: NOT_APPLICABLE,
    featureVersion: NOT_APPLICABLE,
    anchorProductSku: (cartOptions === null || cartOptions === void 0 ? void 0 : cartOptions.anchorProductSku) || NOT_APPLICABLE
  };
  const isFromPackages = isFromPackagePageOrPackageMini(path);
  if (Array.isArray(cartReqParams)) {
    if (isFromPackages) {
      return cartReqParams.map(_ref3 => {
        let {
          itemId,
          displayPosition = NOT_APPLICABLE
        } = _ref3;
        return {
          productInfo: {
            sku: itemId
          },
          displayPosition,
          recommendation
        };
      });
    }
    return cartReqParams.map(_ref4 => {
      let {
        itemId,
        displayPosition
      } = _ref4;
      return {
        productInfo: {
          sku: itemId
        },
        displayPosition
      };
    });
  }
  return (cartOptions === null || cartOptions === void 0 ? void 0 : cartOptions.component) === SHOPPABLE_IMAGES_DRAWER ? [{
    productInfo: {
      sku: cartReqParams === null || cartReqParams === void 0 ? void 0 : cartReqParams.itemId
    },
    index: 'n/a'
  }] : [{
    productID: cartReqParams === null || cartReqParams === void 0 ? void 0 : cartReqParams.itemId,
    index: ''
  }];
};
export const addToCartAnalytics = () => {
  // @todo logic for dpd atc click
  // https://github.homedepot.com/thd-olt-component/hdhome-analytics/blob/master/events/dpd.js#L35

  window.LIFE_CYCLE_EVENT_BUS.on('cart.add-to-cart', _ref5 => {
    let {
      output
    } = _ref5;
    const {
      cartReqParams,
      cartOptions,
      path = []
    } = output;
    if (eventOriginatedFromProductPodOrFbt(path) && !eventOriginatedFromPromotionProducts(path) || eventOriginatedFromApplianceBundles(path)) return;
    const {
      pageType = ''
    } = getState() || {};
    digitalData.event = digitalData.event || [];
    if (pageType !== 'browse') {
      const section = getSectionFromPath({
        path,
        cartOptions
      });
      const target = getTargetFromPath({
        path
      });
      const items = getItemsFromCartReqParams(cartReqParams, cartOptions, path);
      const isSample = (cartOptions === null || cartOptions === void 0 ? void 0 : cartOptions.section) === 'order sample';
      const isBipPage = pageType === BIP_PAGE;
      const sharedSection = (cartOptions === null || cartOptions === void 0 ? void 0 : cartOptions.sharedSection) || 'n/a';
      const component = (cartOptions === null || cartOptions === void 0 ? void 0 : cartOptions.component) || '';
      const eventName = component === SHOPPABLE_IMAGES_DRAWER || Array.isArray(cartReqParams) && !isSample && !isBipPage ? 'cart addition info' : 'cart add location';
      const ddoStashEvent = {
        eventInfo: {
          eventName
        },
        category: {
          primaryCategory: STASH
        },
        eventMode: STASH,
        stash: {
          component,
          item: items,
          pageType,
          section,
          sharedSection,
          target
        }
      };
      digitalData.event.push(ddoStashEvent);
    }
  });
};
export const quickAddToCartLocation = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('cart.quick-add-location', _ref6 => {
    let {
      output
    } = _ref6;
    const {
      data
    } = output;
    const ddoStashEvent = {
      category: {
        primaryCategory: STASH
      },
      eventInfo: {
        eventName: 'cart add location'
      },
      eventMode: STASH,
      stash: {
        component: data.component || 'n/a',
        pageType: data.pageType || 'quick add',
        section: data.section || 'quick add',
        sharedSection: 'n/a',
        target: data.target || 'atc'
      }
    };
    digitalData.event.push(ddoStashEvent);
  });
};
export const quickAddToCartClick = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('cart.quick-add-click', _ref7 => {
    var _data$cartObjectData, _data$cartObjectData2, _data$cartObjectData3, _data$cartObjectData4, _data$cartObjectData5, _data$cartObjectData6, _digitalData$cart, _digitalData$cart2;
    let {
      output
    } = _ref7;
    const {
      data
    } = output;

    // handle stash event
    const ddoStashEvent = {
      category: {
        primaryCategory: data.primaryCategory
      },
      eventInfo: {
        eventName: data.eventName
      },
      cart: {
        cartID: (_data$cartObjectData = data.cartObjectData) === null || _data$cartObjectData === void 0 ? void 0 : _data$cartObjectData.cartID
      },
      item: data.items || []
    };
    digitalData.event.push(ddoStashEvent);

    // update cart Object
    const cartObjItems = ((_data$cartObjectData2 = data.cartObjectData) === null || _data$cartObjectData2 === void 0 ? void 0 : _data$cartObjectData2.items) || [];
    const cartObj = _objectSpread(_objectSpread({}, digitalData.cart), {}, {
      cartID: (_data$cartObjectData3 = data.cartObjectData) === null || _data$cartObjectData3 === void 0 ? void 0 : _data$cartObjectData3.cartID,
      price: (_data$cartObjectData4 = data.cartObjectData) === null || _data$cartObjectData4 === void 0 ? void 0 : _data$cartObjectData4.cartTotal,
      uniqueSkuCount: (_data$cartObjectData5 = data.cartObjectData) === null || _data$cartObjectData5 === void 0 ? void 0 : _data$cartObjectData5.uniqueSkuCount,
      quantityTotal: (_data$cartObjectData6 = data.cartObjectData) === null || _data$cartObjectData6 === void 0 ? void 0 : _data$cartObjectData6.quantityTotal
    });
    if (digitalData !== null && digitalData !== void 0 && (_digitalData$cart = digitalData.cart) !== null && _digitalData$cart !== void 0 && _digitalData$cart.item && Array.isArray(digitalData === null || digitalData === void 0 ? void 0 : (_digitalData$cart2 = digitalData.cart) === null || _digitalData$cart2 === void 0 ? void 0 : _digitalData$cart2.item)) {
      // Overwrite existing cart object properties and push new item to it
      digitalData.cart = _objectSpread(_objectSpread({}, digitalData.cart), cartObj);
      digitalData.cart.item.push(...cartObjItems);
      return;
    }
    digitalData.cart = _objectSpread(_objectSpread({}, cartObj), {}, {
      item: cartObjItems
    });
  });
};
//# sourceMappingURL=add-to-cart.listener.analytics.js.map